<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import JSZip from "jszip";
import FileSaver from "file-saver";
import config from "@/utils/config";
// import Vue from 'vue'
// import Info from './info.vue'
// import Repair from './repair.vue'
// import Track from './track.vue'
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "device",
        key: "id",
        url: {},
        output: false,
        order: "updateTime",
        qrCode: "qrCode",
      },
      query: {
        state: 4,
      },
      actions: [
        {
          label: "导出标签",
          icon: "md-cloud-download",
          type: "info",
          onClick: this.downloadCodeImg,
          auth: "system/devicescrap/downloadCodeImg",
        },
        {
          label: "导出资产",
          icon: "md-download",
          type: "info",
          onClick: this.exportData.bind(this, "资产列表", 1),
          auth: "system/devicescrap/exportData",
        },
      ],
      filters: [
        {
          label: "厂家",
          name: "manufacturer",
          KeyEnter: this.search,
          value: "",
          type: "input",
        },
        {
          label: "型号",
          name: "facilityType",
          KeyEnter: this.search,
          value: "",
          type: "input",
        },
        {
          label: "资产分类",
          name: "typeId",
          value: "",
          type: "select",
          KeyEnter: this.search,
          dropList: [],
        },
        // {
        //   label: "资产选择",
        //   name: "facilityNum",
        //   value: "",
        //   type: "select",
        //   KeyEnter: this.search,
        //   dropList: [],
        // },
        {
          label: "资产名称",
          name: "facilityName",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "SN码",
          KeyEnter: this.search,
          name: "sn",
          value: "",
          type: "input",
        },
        {
          label: "资产归属",
          name: "assetOwnership",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "资产编号",
          KeyEnter: this.search,
          name: "assetNum",
          value: "",
          type: "input",
        },
        {
          label: "IP/MAC",
          KeyEnter: this.search,
          name: "ipMac",
          value: "",
          type: "input",
        },
        {
          label: "责任人",
          KeyEnter: this.search,
          name: "liablePerson",
          value: "",
          type: "input",
        },
      ],
      menus: [
        {
          label: "使用中",
          name: "deviceretrieval_list",
          auth: "system/deviceretrieval/index",
          badge: { mname: "decicestate", scene: "2" },
        },
        {
          label: "库存中",
          name: "device_list",
          auth: "system/device/index",
          badge: { mname: "decicestate", scene: "1" },
        },

        {
          label: "已损坏",
          name: "devicedamage_list",
          auth: "system/devicedamage/index",
          badge: { mname: "decicestate", scene: "3" },
        },
        {
          label: "已报废",
          name: "devicescrap_list",
          auth: "system/devicescrap/index",
          badge: { mname: "decicestate", scene: "4" },
        },
        // {
        //   label: "备用库",
        //   name: "devicestandby_list",
        //   auth: "system/devicestandby/index",
        //   badge: { mname: "decicestate", scene: "5" },
        // },
        {
          label: "空码库",
          name: "Emptycode_list",
          auth: "",
          badge: { mname: "decicestate", scene: "6" },
        },
        // {
        //   label: "资产分类",
        //   name: "deviceClass_list",
        //   auth: "system/deviceClass/index",
        // },
        // { label: '入库记录', name: 'deviceRecordretrieval_list', auth: '' },
        // { label: '损坏记录', name: 'deviceRecorddamage_list', auth: '' },
        // { label: '场景管理', name: 'scene_list', auth: '' },
      ],
      tableCols: [
        {
          type: "selection",
          width: 60,
        },
        //       {
        //   title: "ID",
        //   key: "id",
        //   minWidth: 120,
        //   align: "center",
        // },
        {
          title: "资产编号",
          key: "assetNum",
          width: 100,
          align: "left",
          tooltip: "true",
        },
        // {
        //   title: "二维码",
        //   minWidth: 80,
        //   align: "center",
        //   key: "qrCode",
        //   viewimage: true,
        // },
        {
          title: "型号",
          minWidth: 150,
          align: "left",
          key: "facilityType",
        },
        {
          title: "名称",
          key: "facilityName",
          minWidth: 120,
          align: "left",
          tooltip: "true",
        },
        // {
        //   title: "分类",
        //   key: "typeName",
        //   minWidth: 140,
        //   align: "center",
        // },
        // {
        //   title: "系统编号",
        //   key: "facilityNum",
        //   minWidth: 160,
        //   align: "center",
        //   copy: true,
        // },
        {
          title: "品牌",
          minWidth: 100,
          align: "left",
          key: "facilityBrand",
        },

        // {
        //   title: "SN",
        //   minWidth: 150,
        //   align: "center",
        //   key: "sn",
        //   tooltip: true,
        // },
        // {
        //   title: "报废原因",
        //   minWidth: 180,
        //   align: "center",
        //   key: "scrapCause",
        //   tooltip: "true",
        // },
        // {
        //   title: "报废地点",
        //   key: "scrapSite",
        //   width: 180,
        //   align: "center",
        //   tooltip: "true",
        //   render: (h, params) => {
        //     return h("div", [
        //       h(
        //         "span",
        //         {
        //           style: {
        //             display: "inline-block",
        //             width: "100%",
        //             overflow: "hidden",
        //             textOverflow: "ellipsis",
        //             whiteSpace: "nowrap",
        //           },
        //           domProps: {
        //             title: params.row.scrapSite,
        //           },
        //         },
        //         params.row.scrapSite
        //       ),
        //     ]);
        //   },
        // },
        // {
        //   title: "报废时间",
        //   width: 150,
        //   align: "center",
        //   key: "scrapTime",
        //   render: (h, params) => {
        //     const row = params.row;
        //     const text = row.scrapTime.slice(0, 16);
        //     return <span>{text}</span>;
        //   },
        // },
        // {
        //   title: "资产归属",
        //   key: "assetOwnership",
        //   minWidth: 120,
        //   align: "center",
        //   tooltip:true
        // },
        // {
        //   title: "责任人",
        //   key: "liablePerson",
        //   minWidth: 120,
        //   align: "center",
        // },

        // {
        //   title: "图片",
        //   minWidth: 80,
        //   align: "center",
        //   key: "facilityImg",
        //   viewimage: true,
        // },
        {
          title: "盘点次数",
          key: "checkCount",
          width: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row
            const text = row.checkCount == null ? 0: row.checkCount
            return <span style={{ 'font-size': '14px' }}>{text}</span>
          },
        },
        {
          title: "状态",
          width: 100,
          align: "center",
          key: "state",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.state == 1
                ? "库存中"
                : row.state == 2
                ? "使用中"
                : row.state == 3
                ? "已损坏"
                : row.state == 4
                ? "已报废"
                              : row.state == 5
                                  ? "备用库"
                : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },

        {
          title: "操作",
          align: "center",
          width: 200,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              // let directives = [];
              let directives = [
                { name: "auth", value: "system/devicescrap/info" },
              ];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.handleEdit(currentRow)}
                  type="default"
                  style={{
                    border:"none",
                    color: "#4991ff" }}
                >
                  详情
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              // let directives = [];
              let directives = [
                { name: "auth", value: "system/devicescrap/info" },
              ];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toInfo(currentRow)}
                  type="default"
                  style={{
                    border:"none",
                    color: "#4991ff" }}
                >
                  记录
                </Button>
              );
            },
            // (vm, h, currentRow, param) => {
            //   // let directives = [];
            //   let directives = [
            //     { name: "auth", value: "system/devicescrap/record" },
            //   ];
            //   return (
            //     <Button
            //       {...{ directives }}
            //       size="small"
            //       onClick={() => this.torecord(currentRow)}
            //       type="warning"
            //       style={{ marginLeft: "5px", color: "#f9fafc" }}
            //     >
            //       操作记录
            //     </Button>
            //   );
            // },
          ],
        },
      ],
    };
  },
  created() {
    this.loadLevelData();
    // this.loadfacilityData();
  },
  methods: {
    handleSelect(selected) {
      let ids_arr = [];
      let arry = [];
      for (let index = 0; index < selected.length; index++) {
        const element = selected[index];
        ids_arr.push(element[this.table.key]);
        arry.push(element[this.table.qrCode]);
      }
      this.selected = ids_arr.join(",");
      this.arrys = arry;
    },
    loadIMage(image) {
      return new Promise(function (resolve, reject) {
        try {
          image.onload = function () {
            resolve();
          };
        } catch (e) {
          reject();
        }
      });
    },
    async downloadCodeImg() {
      if (this.arrys == null) $utils.toast.warn("请选择需要导出标签");
      // this.msg('请选择数据')
      const arry = this.arrys;
      for(var j = 0; j < arry.length; j++){
        if (arry[j].indexOf('http') === -1) {
          arry[j] = config.IMAGE_HOST + arry[j];
        }
      }
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth() + 1;
      let date = nowDate.getDate();
      var blogTitle = "资产二维码标签" + year + month + date;
      var zip = new JSZip();
      var imgs = zip.folder(blogTitle);
      var baseList = [];
      // 要下载图片的url
      // var arr = ['http://weixiu.kafukeji.com/admin/profile/upload/code/GK21112200028.png', ];
      // 下载后图片的文件名，个数应与arr对应
      // var imgNameList = ['图片1', '图片2', '图片3'];
      for (var i = 0; i < arry.length; i++) {
        let image = new Image();
        // 解决跨域 Canvas 污染问题
        image.setAttribute("crossOrigin", "anonymous");
        image.src = arry[i];
        await this.loadIMage(image);
        let canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;

        let context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);

        let url = canvas.toDataURL(); // 得到图片的base64编码数据
        canvas.toDataURL("image/png");

        baseList.push(url.substring(22)); // 去掉base64编码前的 data:image/png;base64,
        if (baseList.length === arry.length && baseList.length > 0) {
          for (let k = 0; k < baseList.length; k++) {
            imgs.file(
              arry[k].substring(arry[k].lastIndexOf("/") + 1, arry[k].length),
              baseList[k],
              { base64: true }
            );
          }
          zip.generateAsync({ type: "blob" }).then(function (content) {
            // see FileSaver.js
            FileSaver.saveAs(content, blogTitle + ".zip");
          });
        }
      }
      //如果没有跨越问题直接用图片地址
      // let arry = ['https://api.pwmqr.com/qrcode/create/?url=GK21112500039', 'https://api.pwmqr.com/qrcode/create/?url=GK21112200029'];
      // (arry.forEach(function (url, index) {
      //   setTimeout(() => {//setTimeout是为了防止arry太多导致下载终端机
      //     let link = document.createElement('a')
      //     // 这里是将url转成blob地址，
      //     fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
      //       link.href = URL.createObjectURL(blob)
      //       let temp = url.split("?");
      //       temp = temp[0].split("/");
      //       let name = temp[temp.length - 1];//获得图片名字
      //       link.download = name;
      //       document.body.appendChild(link);
      //       link.click()
      //     })
      //   }, index * 1000)//1000是为了使得浏览器能稳定下载  这个时间可自调建议大于500
      // }))
    },
    loadfacilityData() {
      // 通过pk查询字典数据
      let q = {};
      q.state = 4;
      $utils.api.load("/admin/system/facility/selectList", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.facilityNum;
            xx.name = element.facilityName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "facilityNum") {
              this.filters[index]["dropList"] = (
                element["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    loadLevelData() {
      // 通过pk查询字典数据
      let q = {};
      // q.state=1
      $utils.api.load("/admin/system/facilityType/selectList", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.facilityName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "typeId") {
              this.filters[index]["dropList"] = (
                element["dropList"] || []
              ).concat(dropList);
            }
            for (let index = 0; index < this.filters.length; index++) {
              const element = this.filters[index];
              if (element && element.name == "typeId") {
                this.filters[index]["dropList"] = (
                  element["dropList"] || []
                ).concat(dropList);
              }
            }
            // console.log("dropList typeId", dropList);
          }
        }
      });
    },
    toAdd() {
      $utils.url.push({ name: "device_add", query: { action: "add" } });
    },
    handleEdit(currentRow) {
      $utils.url.push({
        name: "device_edit",
        query: { action: "view", kv: currentRow.id },
      });
    },
    //转单
    toChange(row) {},
    //记录
    toInfo(row) {
      $utils.url.push({
        name: "deviceRecordIndex",
        query: { facilityId: row.id,facilityNo: row.facilityNum  },
      });
    },
    //操作记录
    torecord(row) {
      $utils.url.push({
        name: "deviceRecordIndex",
        query: { facilityId: row.id },
      });
    },
    //导出
    toImport() {},
    //下载模板
    toDownload() {},
  },
};
</script>
<style scoped></style>
